export default __webpack_public_path__ + "static/media/ReuseDirBannerAdMOATX2026.b744d72b.png";